<template>
    <div class="app-header">
        <v-snackbar
            v-model="showSnackbarMessage"
            top center :timeout=10000
            :color="snackbarColor">
            <v-icon dark>warning</v-icon> &nbsp;&nbsp;
            <span v-text="snackbarMessage"></span>
            <v-btn :color="snackbarColor" @click="snackbarMessage = null; showSnackbarMessage = false;" class="black--text snackbar-button">Close</v-btn>
        </v-snackbar>
        <header>
            <template v-if="fromapp !='ida'">
                <div class="brand">
                    <div class="">
                        <div @click="backToTenants()" v-if="(isSuperAdmin || isSuperUser) && showTenantIcon" src="../assets/images/logo_4iqBlack.svg" class="logo logocolor" alt="4IQ Logo"></div>
                        <div v-else src="../assets/images/logo_4iqBlack.svg" class="logocolor" alt="4IQ Logo"></div>
                    </div>
                    <div v-if="docsview" class="logodiv">
                        <span class="tenant-logo"><b>Documentations</b></span>
                    </div>
                    <div v-else-if="showTenantIcon && fromapp != 'bd'" class="logodiv">
                        <!-- Have to check this logic -->
                        <b @click="pagename!='noAppNoDoc' ? backToAppsPage() : ''" class="tenant-name">{{tenantName}}</b>
                    </div>
                    <div v-if="fromapp == 'bd'" class="tenant-logo logodiv">
                        <!-- <span class="tenant-logo"> -->
                            <span class="app-title">Alert Dashboard</span>
                            <!-- <img src="../assets/images/alertdashboard.svg" class="app-title spacing"/> -->
                            <span class="app-title beta-version">Beta</span>
                        <!-- </span> -->
                    </div>
                </div>
                <div class="navbar-center">
                    <ul class="apps-menu">
                        <li class="apps" v-for="(value, key) in availableApps" :key="key"
                        :class="activeApp == key ? 'active' : ''" @click="switchApp(key)">
                        <a v-text="value"></a></li>
                    </ul>
                </div>
            </template>

            <div :class="fromapp !='ida' ? 'header-icon-options-div' : 'ida-header header-icon-options-div'">
                <div class="header-icons-div">
                    <img v-if="fromapp=='ep'" src="../assets/images/user-menu-icon-white.svg" class="user-icon app-icons" @click="closeSettings()"/>
                    <v-icon v-else title="User Menu" @click="closeSettings()">account_circle</v-icon>
                </div>
                <!-- Apps Panel -->
                <div class="header-icons-div" v-if="appsInfo && appsInfo.length > 1 && isSuperAdmin == false">
                    <v-icon title="Apps" @click="showAppsPanel = !showAppsPanel; showSettings = false ; showProfileSettings = showAdminSettings = false;">apps</v-icon>
                </div>
                <div class="header-icons-div" v-if="userCurrentAppInfo['app_doc']" >
                    <v-icon title="Help Docs" @click="launchDocPage()">help_outline</v-icon>
                </div>
                <div class="header-icons-div" v-if="fromapp !='ug' && (enableAppsPage || isSuperAdmin || isAppAdmin || isTenantAdmin)">
                    <template v-if="showTenantIcon && fromapp == 'bd'">
                        <span @click="pagename!='noAppNoDoc' ? backToAppsPage() : ''" class="tenant-logo remove-border"><b>{{tenantName}}</b></span>
                    </template>
                </div>
            </div>

            <div class="user-settings-div" v-if="showSettings" v-on-clickaway="away">
                <div class="user-settings">
                    <div class="user-info-div">
                        <span class="user-icon">
                            <img src="../assets/images/user-menu-icon-white.svg" />
                        </span>
                        <div class="user-info">
                            <h6 class="user-name">{{userInfo['username']}}@{{userInfo['domain']}}</h6>
                            <div class="user-role" v-if="fromapp=='bd'">
                                <span class="userrole-span">{{isSuperAdmin ? 'Super Admin' : isEditor ? 'Editor' : 'User'}}</span>
                            </div>
                            <div class="user-role" v-else>
                                <span class="userrole-span">{{isSuperAdmin ? 'Super Admin' : 'User'}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="user-settings-menu">
                        <ul>
                            <li :class="showProfileSettings ? 'active' : ''"
                            @click="showProfileSettings = ! showProfileSettings ; showAdminSettings = false;">
                                <div class="item-icon"><i class="material-icons">face</i></div>
                                <div class="item-name"><span>Profile</span></div>
                                <div class="item-icon item-icon-right">
                                    <i class="material-icons" v-if="!showProfileSettings">
                                    keyboard_arrow_down</i>
                                    <i class="material-icons" v-else>keyboard_arrow_up</i>
                                </div>
                            </li>
                            <template v-if="showProfileSettings">
                                <li class="sub-user-settings-menu"  v-if="userInfo['has_2fa']" @click="showSettings = false; showModal = true">
                                    <div class="item-icon"><i class="material-icons">mobile_friendly</i></div>
                                    <div class="item-name"><span>Reset 2FA</span></div>
                                </li>
                                <!-- <li class="sub-user-settings-menu"  v-if="userInfo['has_2fa']" @click="showSettings = false; showBackupCodesModal = true">
                                    <div class="item-icon"><i class="material-icons">list_alt</i></div>
                                    <div class="item-name"><span>2FA Backup Codes</span></div>
                                </li> -->
                                <li class="sub-user-settings-menu sub-user-settings-menu-last" @click="showSettings = false; showPasswordModal = true" :class="userInfo['sso_user'] ? 'disabled' : ''">
                                    <div class="item-icon"><i class="material-icons">lock_outline</i></div>
                                    <div class="item-name"><span>Change Password</span></div>
                                </li>
                            </template>

                            <template v-if="fromapp=='ida'">
                                <li :class="showAdminSettings ? 'active' : ''" v-if="isSuperAdmin || enableBOUI || enableCheckerUI"
                                @click="showAdminSettings = ! showAdminSettings; showProfileSettings = showExploreToSettings = false;">
                                    <div class="item-icon"><i class="material-icons">developer_board</i></div>
                                    <div class="item-name"><span>Admin Tools</span></div>
                                    <div class="item-icon item-icon-right">
                                        <i class="material-icons" v-if="!showAdminSettings">
                                        keyboard_arrow_down</i>
                                        <i class="material-icons" v-else>keyboard_arrow_up</i>
                                    </div>
                                </li>
                                <template v-if="showAdminSettings">
                                    <li class="sub-user-settings-menu" v-if="enableBOUI || isSuperAdmin" @click="launchIDAApp('bo')">
                                        <div class="item-icon"><i class="material-icons">settings_backup_restore</i></div>
                                        <div class="item-name"><span>Back-Office UI</span></div>
                                    </li>
                                    <li class="sub-user-settings-menu sub-user-settings-menu-last" v-if="enableCheckerUI || isSuperAdmin" @click="launchIDAApp('checker')">
                                        <div class="item-icon"><i class="material-icons">settings_brightness</i></div>
                                        <div class="item-name"><span>Checker UI</span></div>
                                    </li>
                                </template>
                            </template>

                            <li id="backToTenants" @click="backToTenants()" v-if="isSuperAdmin && showTenantIcon">
                                <div class="item-icon"><i class="material-icons">reply</i></div>
                                <div class="item-name"><span>Back to Tenants</span></div>
                            </li>
                            <!-- <li id="backToApps" @click="backToAppsPage()" v-if="fromapp !='ug' && enableAppsPage && (isSuperAdmin || isAppAdmin || isTenantAdmin)"> -->
                            <li id="backToApps" @click="backToAppsPage()" v-if="fromapp !='ug' && (enableAppsPage || isSuperAdmin || isAppAdmin || isTenantAdmin)">
                                <div class="item-icon"><i class="material-icons">reply_all</i></div>
                                <div class="item-name"><span>Back to Apps</span></div>
                            </li>

                            <li id="backToDocs" @click="backToDocsPage()" v-if="enableDocsPage && !docsview">
                                <div class="item-icon"><i class="material-icons">help_outline</i></div>
                                <div class="item-name"><span>Constella Docs Home</span></div>
                            </li>
                            <li id="tnc" @click="showSettings = false; showTnCView = true" v-if="userCurrentAppInfo['app_tnc']">
                                <div class="item-icon"><i class="material-icons">playlist_add_check</i></div>
                                <div class="item-name"><span>Terms of use</span></div>
                            </li>

                            <li id="support4iQ">
                                <div class="item-icon"><i class="material-icons">build</i></div>
                                <!-- <div class="item-name" @click="showSupport4iQPopup = true"><span>Contact 4iQ Support</span></div> -->
                                <div class="item-name"><span><a href="mailto:support@constellaintelligence.com?subject=Constella IDHunt Core Support" target="new">Contact Constella Support</a></span></div>
                            </li>

                            <li id="feedback" v-if="fromapp == 'bd'">
                                <div class="item-icon"><i class="material-icons">feedback</i></div>
                                <!-- <div class="item-name" @click="showSupport4iQPopup = true"><span>Contact 4iQ Support</span></div> -->
                                <div class="item-name"><span><a href="https://4iqnet.atlassian.net/servicedesk/customer/portal/3/group/-1" target="new">Help Center</a></span></div>
                            </li>

                            <li id="logout" @click="logout">
                                <div class="item-icon"><i class="material-icons">power_settings_new</i></div>
                                <div class="item-name"><span>Logout</span></div>
                            </li>

                        </ul>
                    </div>

                </div>
            </div>
        </header>

        <modalpopupVue v-if="showModal" @close="closePopup" :dialogStatus="showModal"></modalpopupVue>
        <backupCodesModal v-if="showBackupCodesModal" @close="showBackupCodesModal = false" :fromHeader="true" :dialogStatus="showBackupCodesModal"></backupCodesModal>
        <app-terms v-if="showTnCView" :session="accessToken" :app="fromapp" :fromheader="true"></app-terms>
        <changePasswordPopupVue v-if="showPasswordModal" @close="showPasswordModal = false" :dialogStatus="showPasswordModal"></changePasswordPopupVue>
        <appsPanelMenuVue
            v-if="showAppsPanel"
            @close="showAppsPanel = false"
            :appsInfo = appsInfo>
        </appsPanelMenuVue>
        <v-dialog v-model="showSupport4iQPopup" persistent scrollable max-width=600>
            <support4iQ v-if="showSupport4iQPopup" @close="showSupport4iQPopup = false"></support4iQ> 
        </v-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import VueCookies from 'vue-cookies';
import { mixin as clickaway } from 'vue-clickaway';
import modalpopupVue from './modalpopup2fa.vue';
import backupCodesModal from './backupCodesModal.vue';
import changePasswordPopupVue from './changePasswordPopup.vue';
import appTerms from './appTerms.vue';
import appsPanelMenuVue from './appsPanelMenu.vue';
import {hideLoadIcon,showLoadIcon} from '../assets/utils/load.js';
import support4iQ from './support4iQ';
export default {
    name: 'AppHeader',
    mixins: [ clickaway ],
    props:{
        pagename: {
            type: String,
            default: null
        },
        fromapp: {
            type: String
        },
        availableApps: {
            type: Object
        },
        activeApp: {
            type: String
        },
    },
    data () {
        return {
            // seeting flags
            showSettings: false,
            showProfileSettings: false,
            showAdminSettings: false,
            // modal flags
            showModal: false,
            showBackupCodesModal: false,
            showPasswordModal: false,
            // userdetails
            userInfo: {},
            isSuperAdmin: false,
            isSuperUser: false,
            isTenantAdmin: null,
            isAppAdmin: null,
            isEditor:false,
            tenantName: null,
            enableAppsPage: null,
            enableDocsPage: null,
            // app level flags
            userCurrentAppInfo: {},
            userCurrentAppRoles: [],
            enableBOUI: false,
            enableCheckerUI: false,
            accessToken: null,
            showTnCView: false,
            showAppsPanel: false,
            appsInfo :[],
            docsInfo :[],
            hide:null,
            showSupport4iQPopup: false,
            showSnackbarMessage:'',
            snackbarMessage: '',
            snackbarColor:'error-banner'
        }
    },
    components: {
        modalpopupVue,
        backupCodesModal,
        appTerms,
        changePasswordPopupVue,
        appsPanelMenuVue,
        support4iQ
    },
    created(){
        let self = this;

        if(window.location.search && window.location.search.split('at=')[1]){
            self.accessToken = window.location.search.split('at=')[1];
        }

        if(!self.loggedInUserInformation){
            self.initializeData({accessToken: self.accessToken});
        }else{
            self.setHeaderData();
        }
        
        if(self.fromapp != 'ug'){
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/getUserAppInfo',  {
                params: {
                    session: self.accessToken
                }
            }).then((res) => {
                try{
                    if(res.status == 200){
                        let resData = res['data'];
                        if(typeof(res['data']) == 'string'){
                            resData = JSON.parse(resData);
                        }
                        self.userCurrentAppRoles = resData['app_roles'];
                        if(self.fromapp == 'bd'){
                            self.$emit('getAppRoles', self.userCurrentAppRoles);
                            if(self.userCurrentAppRoles.includes('Editor')){
                                self.isEditor = true;
                            }
                        }
                        if(self.userCurrentAppRoles.includes('Admin')){
                            self.enableBOUI = true;
                        }
                        if(self.userCurrentAppRoles.includes('Analyst')){
                            self.enableCheckerUI = true;
                        }
                        self.userCurrentAppInfo = resData;

                        self.$emit('getAppType', self.userCurrentAppInfo['appType']);
                        if(self.userCurrentAppInfo['app_doc']){
                            self.$parent.hashelpdoc = true;
                        }

                        // For App expiration alert message
                        if(resData['expiration_date']){
                            const dateDiff = Math.floor((new Date(resData['expiration_date']).getTime() - new Date().getTime())/(1000 * 3600 * 24))+1;
                            if(dateDiff != null && dateDiff > -1 && dateDiff <= 7){
                                self.snackbarColor = 'warning-banner';
                                self.snackbarMessage = 'App getting expired in '+dateDiff+' days';
                                self.showSnackbarMessage = true;
                            }
                        }
                    }else if(res.status == 201){
                        window.location = '/#apps';
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                console.log("API Error!!");
            });
        }
    },
    computed: {
        ...mapState({
            loggedInUserInformation: state => state.loginDetails.loggedInUserInformation,
        }),
        showTenantIcon() {
            return this.pagename != 'tenants';
        },
        docsview() {
            return this.pagename == 'docs';
        }
    },
    watch: {
        pagename() {
            this.showTenantIcon = pagename != 'tenants' ? true : false;
            this.docsview = pagename == 'docs' ? true : false;
        },
        loggedInUserInformation(){
            let self = this;
            if(self.loggedInUserInformation){
                self.setHeaderData();
            }
        }
    },
    methods: {
        ...mapActions({
            initializeData: 'loginDetails/initializeData',
        }),
        setHeaderData() {
            let self = this;
            self.userInfo = self.loggedInUserInformation;
            self.tenantName = self.loggedInUserInformation['switched_tenant'] ?  self.loggedInUserInformation['switched_tenant']['name'] : ' ';

            self.isSuperAdmin = self.loggedInUserInformation['is_superadmin'];
            self.isSuperUser = true;
            self.isTenantAdmin = self.loggedInUserInformation['is_tenantadmin'];
            self.isAppAdmin = self.loggedInUserInformation['is_appadmin'];
            
            self.enableAppsPage = self.isSuperAdmin ? true : self.loggedInUserInformation['enable_appspage'];
            self.enableDocsPage = self.isSuperAdmin ? true : self.loggedInUserInformation['enable_docspage'];

            if(self.fromapp != 'ug'){
                self.appsInfo = self.loggedInUserInformation['apps_information'];
                self.docsInfo = self.loggedInUserInformation['docs_information'];
                if (self.docsInfo.length && self.userCurrentAppInfo['doc_name']){
                    self.userCurrentAppInfo['app_doc'] = true;
                }
                if(self.appsInfo.length > 1) {
                    self.$parent.hasappsdoc = true;
                }
            }
            if(self.fromapp == 'ug' && self.loggedInUserInformation['docs_information'].includes('Tenant Administration')){
                self.userCurrentAppInfo['app_doc'] = true;
                self.userCurrentAppInfo['doc_name'] = "Tenant Administration";
            }
        },
        closeSettings() {
            this.showSettings = !this.showSettings; 
            this.showAppsPanel = this.showProfileSettings = this.showAdminSettings = false;
        },
        backToTenants(){
            if(this.fromapp == 'ug'){
                this.$router.push('/tenants');
            }else{
                window.location = '/#tenants';
            }
        },
        backToAppsPage(){
            if(this.fromapp == 'ug'){
                this.$router.push('/apps');
            }else{
                window.location = '/#apps';
            }
        },
        backToDocsPage(){
            window.open('/#docs/all', "_blank");
        },
        launchDocPage(){
            window.open('/documentation/'+this.userCurrentAppInfo['doc_name']+'/index.html', "_blank");
        },
        launchIDAApp(app){
            window.location.href = "/apps/ida/"+app+"/index/?at="+ this.accessToken;
        },
        logout(){
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/logout/')
			.then((res) => {
                try{
                    sessionStorage.clear();
                    localStorage.clear();
                    if(this.userInfo['sso_redirected_user']) location.href = "/login?loggedOut=true";
                    else location.href = "/login";
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
			}, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
				//console.log("api failed with error: ", error);
			})
        },
        away(){
          this.showSettings = false;
        },
        switchApp(app){
            this.$emit('switchApp', app);
        },
        closePopup(flag){
            this.showModal = false; 
            if(flag){
                this.showBackupCodesModal = true;
            }
        },
        showLoadIcon,
        hideLoadIcon
    }
}
</script>
<style scoped lang="scss">
.snackbar-button {
    box-shadow: none ;
    }

</style>